import React from "react";
import "../../../../sass/components/full-page-button.scss";

interface Props {
  content: string;
  href: string;
  iconUrl?: string;
}

export const FullPageButton = ({
  content,
  href,
  iconUrl = "/assets/images/stay_compliant/single_page_document.svg",
}: Props) => {
  const handleClick = () => {
    window.location.href = href;
  };

  return (
    <div className="container mt-0 mb-0">
      <button className="responsive-button mt-xs mb-xs" onClick={handleClick}>
        <div className="d-flex">
          <img src={iconUrl} alt="" width="24px" style={{ verticalAlign: "middle" }} />
          <div className="button-content ml-xxs">{content}</div>
        </div>
        <div className="button-content">
          <img src="/assets/images/stay_compliant/chevron_right.svg" alt="Open" />
        </div>
      </button>
    </div>
  );
};
